import {Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, ViewChild} from '@angular/core';
import {StandardFormMetaInfo} from '../standard-form-builder/standard-form-meta-info.model';
import {IconModel} from '../../../../api/src/icon/icon.model';
import {environment} from '../../../../../src/environments/environment';


@Component({
    selector: 'in-fileupload-form-builder',
    templateUrl: './fileupload-form-builder.component.html',
    styleUrls: ['./fileupload-form-builder.component.scss'],
    standalone: false
})
export class FileuploadFormBuilderComponent implements OnInit, OnChanges {
  @Input() panelTitle = '';
  @Input() isOneColumn = false;
  @Input() meta: StandardFormMetaInfo[];
  @Input() values: any[];
  @Input() icons: IconModel[];
  @Input() itemOptions = {};
  @Input() buttons;
  @Input() chooseLabel;
  @Input() uploadLabel;
  @Output() save = new EventEmitter<any>();
  @Output() create = new EventEmitter<any>();
  @Output() copy = new EventEmitter<any>();
  @Output() delete = new EventEmitter<any>();
  @Output() upload = new EventEmitter<any>();
  @Input() disabled = {save: false, create: false, copy: false};

  buttonsLabels = {save: 'SAVE', create: 'CREATE', copy: 'COPY', delete: 'DELETE', savetitle: 'SAVE AND UPLOAD'};
  @ViewChild('uploadForm', {static: false}) uploadForm: ElementRef;

  readonly DEFAULT_MAX_LENGTH = 65535;
  public readonly TYPE_ICON = 1;
  public readonly TYPE_IMAGE = 2;

  constructor() {
  }

  ngOnInit() {
    return;
  }

  ngOnChanges() {
    this.checkRequired();
  }

  onSave() {
    this.onUploadIcon(this.uploadForm, this.uploadForm);
    this.save.next(this.values);
  }

  onCreate() {
    this.create.next(this.values);
  }

  onCopy() {
    this.copy.next(this.values);
  }

  onDelete() {
    this.delete.next(this.values);
  }

  onDeleteIcon(id) {
    const icon = this.icons.find(_icon => _icon.id === id);
    this.delete.next(icon);
  }


  onUploadIcon(event, uploadForm) {
    event.files.forEach(file => {
      this.upload.next(file);
    });
    uploadForm.files = [];
    if (uploadForm.clearAll) {
      uploadForm.clearAll();
    }
  }


  checkRequired() {
    if (this.meta.find(_meta => (_meta.required && !this.values[_meta.field])
      || (_meta.constraints && (this.values[_meta.field] && this.values[_meta.field].length > _meta.constraints.maxLength)))) {
      this.disabled.save = true;
      this.disabled.create = true;
      return;
    }
    this.disabled.save = false;
    this.disabled.create = false;
  }

  compareById(a, b) {
    if (a === null || b === null) {
      return false;
    }
    if (a && b && !(a.id || b.id)) {
      return a && b && a === b;
    }
    return a && b && a.id === b.id;
  }

  compareByValue(a, b) {
    return a && b && a === b;
  }

  getImageUrl(item) {
    if (item) {
      return `${environment.backEndUrlPrefix + '/'}db/icon/${item.id}/img`;
    }
    return '';
  }


}
